<div style="display: flex; flex-direction: row; color: white" >
  <span matSnackBarLabel>{{ data.message }}</span>
  <div matSnackBarActions>
    <button matSnackBarAction mat-button (click)="snackBarRef.dismissWithAction()">
      {{ data.action }}
    </button>
  </div>
</div>
